import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo } from 'react';
import { StyleSheet } from 'react-native';
import { theme } from '@xbto/design-system';
import { Col, Row, TextBody } from '../../atoms';
import { CurrencyIcon } from '../../molecules';
import { ApyLabel } from '../apy-label';
function CurrencyIdentityComponent({ apy, code, displayCode, name, trending = false, size, }) {
    const isCompact = !displayCode;
    return (_jsxs(Row.L, { style: $.container, children: [_jsx(CurrencyIcon, { code: code, size: size }), _jsxs(Col, { style: $.content, children: [_jsxs(Row.L, { style: $.title, children: [_jsx(TextBody, { em: true, children: isCompact ? name || code : displayCode }), !!apy && apy.gt(0) && _jsx(ApyLabel, { value: apy }), trending && _jsx(TextBody, { em: true, children: "\uD83D\uDD25" })] }), !isCompact && _jsx(TextBody, { small: true, children: name || code })] })] }));
}
export const CurrencyIdentity = memo(CurrencyIdentityComponent);
const $ = StyleSheet.create({
    container: {
        gap: theme.spacing['3'],
    },
    content: {
        gap: theme.spacing['0.5'],
    },
    title: {
        gap: theme.spacing['1'],
    },
});
